import { Button, Typography } from '@mui/material';
import {
  AgreementStatus as AgreementStatusEnum,
  type InteractionStatus,
} from '@/common/hooks/referrals/types';
import { Link } from '@/components/Link';
import { TXM_REFERRALS_PATH } from '@/constants';
import {
  TrackReferralsEvent,
  useTrackReferralsAnalytics,
} from '$analytics/useTrackAnalytics/domains/referrals';

type AgreementStatusProps = {
  referralId: string;
  agreementStatus: string;
  transactionStatus: InteractionStatus;
};

export function AgreementStatus(props: AgreementStatusProps) {
  const { referralId, agreementStatus, transactionStatus } = props;

  const referralAgreementHref = `${TXM_REFERRALS_PATH}/${referralId}/agreement`;

  const trackEvent = useTrackReferralsAnalytics();

  switch (agreementStatus) {
    case AgreementStatusEnum.PartiallySigned:
    case AgreementStatusEnum.Sent:
      return <Typography variant="body2">Awaiting Signature</Typography>;
    case AgreementStatusEnum.Completed:
      return <Typography variant="body2">Signed</Typography>;
    default:
      return (
        <Button
          href={referralAgreementHref}
          LinkComponent={Link}
          onClick={() => {
            trackEvent(TrackReferralsEvent.ClickViewReferralOnListPage, {
              eventTarget: 'agreement_status_link',
              interactionId: referralId,
              agreementStatus,
              transactionStatus,
            });
          }}
          sx={{
            height: {
              xs: 18,
              md: '100%',
            },
          }}
          variant="link"
        >
          Continue Editing
        </Button>
      );
  }
}
